/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { RouteObject } from 'react-router-dom';
import { NotFoundPage } from './navigation';

export const getNotFoundPageRoute = (props: any): RouteObject | any => {
  return {
    path: '*',
    element: <NotFoundPage navigation={{}} />,
  };
};
